{
  "page": {
    "title": "Панель управления",
    "refresh": "Обновить",
    "refreshAriaLabel": "Обновить данные",
    "loading": "Загрузка..."
  },
  "filters": {
    "allEmployees": "Все сотрудники",
    "employee": "Сотрудник",
    "timeRange": "Период",
    "from": "С",
    "to": "По",
    "ranges": {
      "today": "Сегодня",
      "thisWeek": "Эта неделя",
      "thisMonth": "Этот месяц",
      "custom": "Произвольный"
    },
    "filteredByCard": "Фильтр: {{label}}",
    "employeesShown": "{{count}} сотр.",
    "clearFilter": "Сбросить фильтр"
  },
  "kpi": {
    "activeEmployees": "Активные сотрудники",
    "onSiteNow": "Сейчас на работе",
    "onSiteNowHint": "Сотрудники, у которых есть вход и ещё нет выхода за сегодня.",
    "totalWork": "Всего работы",
    "totalBreak": "Всего перерывов",
    "totalOvertime": "Всего сверхурочных",
    "totalPayroll": "Общий фонд оплаты",
    "lateCount": "Опозданий",
    "absentCount": "Отсутствий",
    "punctuality": "Пунктуальность",
    "ofTotal": "{{n}} из {{total}} сотрудников",
    "ofPresent": "{{n}} из {{total}} дней присутствия",
    "failedToLoad": "Не удалось загрузить данные KPI.",
    "ariaUpVsPrevious": "Рост на {{value}}% по сравнению с предыдущим периодом",
    "ariaDownVsPrevious": "Снижение на {{value}}% по сравнению с предыдущим периодом",
    "onLeave": "В отпуске",
    "absent": "Отсутствуют"
  },
  "charts": {
    "workHoursTrend": "Динамика рабочих часов",
    "punchHeatmap": "Тепловая карта отметок (час дня)",
    "failedToLoadTrend": "Не удалось загрузить данные тренда.",
    "noTrendData": "Нет данных тренда за этот период.",
    "noPunchData": "Нет данных об отметках за этот период.",
    "heatmapLess": "Меньше",
    "heatmapMore": "Больше",
    "days": {
      "mon": "Пн",
      "tue": "Вт",
      "wed": "Ср",
      "thu": "Чт",
      "fri": "Пт",
      "sat": "Сб",
      "sun": "Вс"
    }
  },
  "workHoursTable": {
    "title": "Рабочие часы за выбранный период",
    "subtitle": "Итоги за выбранный период — нажмите на строку для просмотра деталей сотрудника.",
    "noData": "Нет данных о рабочих часах за выбранный период",
    "noDataHint": "Измените фильтры или дождитесь синхронизации данных устройства",
    "noEmployeesInFilter": "Нет сотрудников, соответствующих этому показателю",
    "failedToLoad": "Не удалось загрузить данные рабочих часов. Пожалуйста, попробуйте снова.",
    "columns": {
      "employee": "Сотрудник",
      "days": "Дни",
      "work": "Работа",
      "break": "Перерыв",
      "afterHours": "Сверхурочные",
      "lateDeduction": "Удержание за опоздание ({{currency}})",
      "totalPay": "Итого ({{currency}})"
    }
  },
  "employeePage": {
    "backToDashboard": "Назад к панели управления",
    "payslipLabel": "Расчётный лист:",
    "noProfession": "Профессия не указана",
    "noProfessionHint": "— поля расчёта оплаты будут равны 0. Назначьте ставки в разделе «Сотрудники».",
    "workHoursOverTime": "Динамика рабочих часов",
    "noDataForPeriod": "Нет данных за выбранный период.",
    "dailyBreakdown": "Разбивка по дням",
    "noDailyRecords": "Нет записей за этот период.",
    "failedToLoad": "Не удалось загрузить данные сотрудника",
    "failedToLoadHint": "Попробуйте обновить страницу.",
    "notFound": "Сотрудник не найден или у вас нет доступа.",
    "columns": {
      "date": "Дата",
      "firstIn": "Первый вход",
      "lastOut": "Последний выход",
      "work": "Работа",
      "break": "Перерыв",
      "afterHours": "Сверхурочные",
      "punches": "Отметки",
      "mode": "Режим",
      "status": "Статус",
      "hourlyPay": "Почасовая оплата",
      "afterHoursPay": "Оплата сверхурочных",
      "salaryShare": "Доля оклада",
      "lateDeduction": "Удержание за опоздание",
      "totalPay": "Итого"
    },
    "badges": {
      "statusCodes": "Коды статусов",
      "alternating": "Чередование",
      "unpaired": "Непарные",
      "downloadPayslip": "Скачать расчётный лист в формате {{fmt}}",
      "autoClosed": "Уход проставлен автоматически (конец смены)"
    }
  }
}
